import React from 'react';
import MiniSiteCategoriesTable from '../components/MiniSiteCategoriesTable';

export function MiniSiteCategories() {
  return <MiniSiteCategoriesTable />;
}
